import { Fragment } from 'react'
import _ from 'lodash'
import { Card } from 'antd'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { HyperLink } from '../../../../Common/Form'
import { ConnectedListingLink } from '../../../../Common/ListingLink/ListingLink'
import { getFailedListingIds } from '../../../helper/batch'
import styles from './index.css'

const UpdateFailedListingsCard = props => {
  const { listings, failedMap, proposalTypeName } = props
  const listingIds = getFailedListingIds(listings, failedMap)
  if (_.isEmpty(listingIds)) {
    return null
  }

  const idsStr = _.join(listingIds, COMMA)
  const lastIndex = _.size(listingIds) - 1
  return (
    <>
      <Card className={styles.updateFailedListingsCard}>
        {'賣場 '}
        {_.map(listingIds, (id, index) => (
          <Fragment key={id}>
            <ConnectedListingLink targetListingId={id}>
              {id}
            </ConnectedListingLink>
            {(index !== lastIndex) && `${COMMA} `}
          </Fragment>
        ))}
        {` ${proposalTypeName}提案失敗，您可`}
        <HyperLink
          target='_blank'
          href={`?listingIds=${idsStr}`}
        >
          重新提案
        </HyperLink>
      </Card>
      <br />
    </>
  )
}

export default UpdateFailedListingsCard
